<template>
    <div class="app-detail">
        <div class="app-detail__card">
            <div class="app-detail__title text-w4">
                产品详情
            </div>
            <div class="flex app-detail__main">
                <div class="common__submenu app-detail__submenu">
                    <router-link to="/app-detail/dermx">
                        <div :class="'common__submenu__item dermx ' + (app === 'dermx' ? 'selected' : '')">体素肤知汇</div>
                    </router-link>
                    <router-link to="/app-detail/derms">
                        <div :class="'common__submenu__item derms ' + (app === 'derms' ? 'selected' : '')">体素肤美汇</div>
                    </router-link>
                </div>
                <div :class="'app-detail__body ' + apps[app].app_name">
                    <div class="app-detail__body__appcard flex flex--align-center">
                        <img class="app-detail__body__appcard__left" :src="apps[app].app_img"/>
                        <div v-if="app === 'dermx'" class="app-detail__body__appcard__right">
                            <!-- <div class="app-detail__body__appcard__right__left-quote">“</div> -->
                            <div class="app-detail__body__appcard__right__leading-text">全球首款智能皮肤全病种检测解决方案。通过深度学习算法，对用户上传皮损照片进行皮肤病风险评估分。</div>
                            <div class="app-detail__body__appcard__right__alt">
                                <div class="app-detail__body__appcard__right__alt__text" style="color: rgba(255, 255, 255, 0.7)">全球首款智能</div>
                                <div class="app-detail__body__appcard__right__alt__text" style="color: rgba(255, 255, 255, 0.7)">皮肤全病种检测解决方案。</div>
                                <div class="app-detail__body__appcard__right__alt__text">通过深度学习算法，</div>
                                <div class="app-detail__body__appcard__right__alt__text">对用户上传皮损照片</div>
                                <div class="app-detail__body__appcard__right__alt__text">进行皮肤病风险评估分。</div>
                            </div>
                            <!-- <div class="app-detail__body__appcard__right__right-quote">”</div> -->
                            <div class="flex flex--justify-between app-detail__body__appcard__dermx">
                                <div class="app-detail__body__appcard__right__middle-item">
                                    <div class="app-detail__body__appcard__right__middle-item__bar"></div>
                                    <div class="app-detail__body__appcard__right__middle-item__number">100<span class="special">+</span></div>
                                    <div class="app-detail__body__appcard__right__middle-item__text">可精准识别的皮肤病 <span class="special">*</span></div>
                                </div>
                                <div class="app-detail__body__appcard__right__middle-item">
                                    <div class="app-detail__body__appcard__right__middle-item__bar"></div>
                                    <div class="app-detail__body__appcard__right__middle-item__number">99<span class="special">%</span></div>
                                    <div class="app-detail__body__appcard__right__middle-item__text">皮肤病发情况覆盖率 <span class="special">*</span></div>
                                </div>
                            </div>
                            <div class="flex flex--justify-between app-detail__body__appcard__btns">
                                <router-link to="/document/dermx152">
                                    <Button class="app-detail__body__appcard__btn white">查看 API 文档</Button>
                                </router-link>
                                <router-link to="/guide">
                                    <Button class="app-detail__body__appcard__btn transparent">接入指南</Button>
                                </router-link>
                            </div>
                        </div>
                        <div v-if="app === 'derms'" class="app-detail__body__appcard__right">
                            <div style="margin-bottom: 8px">
                                <div class="flex flex--align-center" style="margin-bottom: 8px">
                                    <div class="app-detail__body__appcard__empty-circle"></div>
                                    <div class="app-detail__body__appcard__derms__title">面部肤质状态检测</div>
                                </div>
                                <div class="app-detail__body__appcard__derms__content">皮肤评分、肤龄、肤质（干油性）、肤色、敏感度、黑眼圈、皱纹、
粗糙度、黑头、毛孔</div>
                            </div>
                            
                            <div style="margin-bottom: 33px">
                                <div class="flex flex--align-center" style="margin-bottom: 8px">
                                    <div class="app-detail__body__appcard__empty-circle"></div>
                                    <div class="app-detail__body__appcard__derms__title">面部皮肤问题分析</div>
                                </div>
                                <div class="app-detail__body__appcard__derms__subtitle">面部炎症</div>
                                <div class="app-detail__body__appcard__derms__content">玫瑰痤疮、激素依赖性皮炎、痤疮、脂溢性皮炎、毛囊炎、扁平苔癣、
红斑狼疮、日光性皮炎、面部湿疹</div>
                                <div class="app-detail__body__appcard__derms__subtitle">面部色素问题</div>
                                <div class="app-detail__body__appcard__derms__content">雀斑、黄褐斑、太田痣、咖啡斑、色素痣、脂溢性角化</div>
                            </div>

                            <div class="flex flex--justify-between app-detail__body__appcard__btns">
                                <router-link to="/document/derms">
                                    <Button class="app-detail__body__appcard__btn white">查看 API 文档</Button>
                                </router-link>
                                <router-link to="/guide">
                                    <Button class="app-detail__body__appcard__btn transparent">接入指南</Button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="app-detail__body__scenarios">
                        <div class="app-detail__body__title">应用场景</div>
                        <div class="app-detail__body__scenarios__items flex flex--wrap flex--justify-between">
                            <div v-for="(s, index) in apps[app].scenarios" :key="index" class="app-detail__body__scenarios__item">
                                <i class="ivu-icon iconfont app-detail__body__scenarios__item__icon" :class="s.icon"></i>
                                <div class="app-detail__body__scenarios__item__title">{{s.title}}</div>
                                <div class="app-detail__body__scenarios__item__content">{{s.content}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="app-detail__body__prices">
                        <div class="app-detail__body__title">价格方案</div>
                        <div v-for="(p, index) in apps[app].prices" :key="index" :class="'app-detail__body__prices__card ' + p.type">
                            <div class="app-detail__body__prices__card__title flex flex--justify-between">
                                <div class="app-detail__body__prices__card__title__mode">{{p.mode}}</div>
                                <div class="app-detail__body__prices__card__title__price">¥{{p.price | formatNum}}</div>
                            </div>
                            <div class="app-detail__body__prices__card__subcard flex flex--justify-between flex--align-center">
                                <div class="flex flex--direction-column">
                                    <div class="app-detail__body__prices__card__subcard__legend">套餐包量(次)</div>
                                    <div class="app-detail__body__prices__card__subcard__content">{{p.amt | formatNum}}</div>
                                </div>
                                <div class="flex flex--direction-column">
                                    <div class="app-detail__body__prices__card__subcard__legend">最大QPS</div>
                                    <div class="app-detail__body__prices__card__subcard__content">{{p.qps}}</div>
                                </div>
                                <div class="flex flex--direction-column">
                                    <div class="app-detail__body__prices__card__subcard__legend">超额费用</div>
                                    <div class="app-detail__body__prices__card__subcard__content">{{p.excess}}</div>
                                </div>
                                <div class="flex flex--direction-column">
                                    <div class="app-detail__body__prices__card__subcard__legend">有效期</div>
                                    <div class="app-detail__body__prices__card__subcard__content">{{p.expire}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import appsData from "@/assets/staticData/appDetail.js";

export default {
  name: 'appDetail',
  props: {
      app: {
          type: String,
          default: 'dermx'
      },
  },
  data() {
      return {
          apps: appsData
      }
  },
}
</script>
<style lang="less">
    @import "static.less";
    @prefix: ~'app-detail';
    .@{prefix} {
        user-select: none;
        
        background: #ECEFF1;
        &__card {
        width: 1008px;
        margin: -8px auto 0 auto;
        // padding-bottom: 64px;
        border-radius: 8px;
        background: white;
        box-shadow: 0 2px 4px 0 rgba(black, 0.1), 0 3px 4px 0 rgba(black, 0.08), 0 1px 5px 0 rgba(black, 0.16);
        }
        &__title {
            font-size: 31px;
            line-height: 48px;
            letter-spacing: -0.86;
            color: rgba(black, 0.54);
            width: 100%;
            padding: 20px 0 11px 16px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        }

        &__main {
            height: calc(100vh - 168px);
        }

        &__submenu {
            width: 225px;
            padding-top: 20px;
            &__item {
                width: 100%;
                padding: 10px 0 10px 16px;
                margin-bottom: 8px;
                font-weight: 500;
                font-size: 14px;
                background-color: white;
                color: rgba(black, 0.54);
                line-height: 20px;
                transition: background-color .2s;

                &:hover {
                    cursor: pointer;
                    background-color: rgba(black, 0.08);
                }

                &.selected {
                    background-color: rgba(black, 0.08);
                    color: @primary-color;
                }
            }
        }

        &__body {
            overflow: auto;
            padding-bottom: 20px;
            border-left: 1px solid rgba(black, 0.08);

            &.dermx {
                & .app-detail__body__appcard {
                    background-color: #867CE9;
                }
                & .app-detail__body__appcard__left__appimg-cover {
                    background-image: linear-gradient(to bottom, transparent 0%, transparent 60%, transparent 60%, #867CE9 100%);
                }

                & .app-detail__body__scenarios__item__title {
                    color: #51458B;
                }
                & .app-detail__body__prices__card__title__price {
                    color: #867CE9;
                }
                & .app-detail__body__prices__card__subcard__legend {
                    color: #867CE9;
                }
                & .app-detail__body__prices__card__subcard {
                    background-color: rgba(134, 124, 233, 0.12);
                }

                & .prepaid .app-detail__body__prices__card__title__price {
                    color: #00BDCD;
                }
                & .prepaid .app-detail__body__prices__card__subcard__legend {
                    color: #00BDCD;
                }
                & .prepaid .app-detail__body__prices__card__subcard {
                    background-color: rgba(0, 189, 205, 0.12);
                }
            }

            &.derms {
                & .app-detail__body__appcard {
                    background-color: #F87EAC;
                }
                & .app-detail__body__appcard__left__appimg-cover {
                    background-image: linear-gradient(to bottom, transparent 0%, transparent 60%, transparent 60%, #F87EAC 100%);
                }

                & .app-detail__body__scenarios__item__title {
                    color: #F87EAC;
                }
                & .app-detail__body__prices__card__title__price {
                    color: #F87EAC;
                }
                & .app-detail__body__prices__card__subcard__legend {
                    color: #F87EAC;
                }
                & .app-detail__body__prices__card__subcard {
                    background-color: rgba(248, 126, 172, 0.12);
                }

                & .prepaid .app-detail__body__prices__card__title__price {
                    color: #20C997;
                }
                & .prepaid .app-detail__body__prices__card__subcard__legend {
                    color: #20C997;
                }
                & .prepaid .app-detail__body__prices__card__subcard {
                    background-color: rgba(32, 201, 151, 0.12);
                }
            }
            &__title {
                font-weight: 400;
                font-size: 31px;
                letter-spacing: 2;
                line-height: 40px;
                color: rgba(black, 0.54);
            }

            &__appcard {
                width: 752px;
                height: 448px;
                box-shadow: 0 24px 38px 3px rgba(black, 0.1), 0 9px 46px 8px rgba(black, 0.08), 0 11px 15px 0 rgba(black, 0.16);
                border-radius: 24px;
                padding: 16px;
                margin: 16px;

                &__btns {
                    width: 250px;
                }

                &__empty-circle {
                    width: 16px;
                    height: 16px;
                    border: 1px solid white;
                    border-radius: 50%;
                }

                &__derms {
                    &__title {
                        margin-left: 8px;
                        font-weight: 500;
                        font-size: 21px;
                        letter-spacing: 1;
                        color: white;
                        line-height: 32px;
                    }

                    &__subtitle {
                        margin-left: 24px;
                        font-weight: 700;
                        font-size: 12px;
                        line-height: 24px;
                        color: white;
                    }

                    &__content {
                        margin-left: 24px;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 24px;
                        color: rgba(white, 0.87);
                        margin-bottom: 16px;
                    }
                }

                &__left {
                    border-radius: 16px;
                    width: 192px;
                    // height: 416px;
                }

                &__right {
                    margin-left: 32px;
                    width: 488px;
                    color: white;
                    &__left-quote, &__right-quote {
                        font-size: 31px;
                        line-height: 18px;
                    }
                    &__alt {
                        display: none;
                    }
                    &__leading-text {
                        width: 448px;
                        line-height: 32px;
                        font-weight: 500;
                        font-size: 21px;
                        color: white;
                        letter-spacing: 1;
                    }

                    &__middle-item {
                        margin-top: 47px;
                        width: 448px;
                        &__bar {
                            width: 216px;
                            height: 4px;
                            border-radius: 4px;
                            background-color: rgba(white, 0.3);
                        }

                        &__number {
                            margin-top: 4px;
                            padding-left: 8px;
                            font-weight: 400;
                            font-size: 40px;
                            line-height: 53px;
                            letter-spacing: -2;
                            color: white;

                            & .special {
                                color: rgba(white, 0.3);
                            }
                        }

                        &__text {
                            margin-top: 3px;
                            margin-bottom: 65px;
                            padding-left: 8px;
                            font-weight: 700;
                            font-size: 12px;
                            line-height: 24px;
                            color: white;

                            & .special {
                                color: #50E3C2;
                            }
                        }
                    }
                }
                
                &__btn {
                    border-radius: 18px;
                    width: 115px;
                    height: 34px;
                    font-size: 14px;
                    line-height: 34px;
                    border: 1px solid white;
                    text-align: center;
                    &.white {
                        background-color: white;
                        color: @primary-color;
                    }

                    &.transparent {
                        background-color: transparent;
                        color: white;
                    }
                }
            }
            &__scenarios {
                margin: 40px 32px 10px 31px;
                &__items {
                    margin-top: 32px;
                    width: 720px;
                }
                &__item {
                    width: 286px;
                    margin-bottom: 58px;
                    &__icon {
                        color: rgba(black, 0.26);
                        font-size: 56px;
                    }

                    &__title {
                        margin-top: 8px;
                        font-weight: 500;
                        font-size: 21px;
                        line-height: 40px;
                        letter-spacing: 1.35;
                    }

                    &__content {
                        margin-top: 3px;
                        font-weight: 500;
                        line-height: 40px;
                        font-size: 14px;
                        color: rgba(black, 0.87);
                    }
                }
            }

            &__prices {
                border-top: 1px solid rgba(black, 0.08);
                padding: 71px 32px 0 31px;
                
                &__card {
                    margin-top: 8px;
                    padding: 8px;
                    width: 720px;
                    height: 168px;
                    background-color: white;
                    border-radius: 8px;
                    box-shadow: 0 0 2px 0 rgba(black, 0.1), 0 2px 2px 0 rgba(black, 0.08), 0 1px 3px 0 rgba(black, 0.16);

                    &__title {
                        &__mode {
                            margin-left: 8px;
                            font-weight: 400;
                            font-size: 18px;
                            line-height: 32px;
                            color: rgba(black, 0.87);
                        }

                        &__price {
                            margin-right: 8px;
                            font-weight: 700;
                            font-size: 18px;
                            line-height: 32px;
                        }

                    }

                    &__subcard {
                        width: 704px;
                        height: 112px;
                        border-radius: 8px;
                        padding: 36px 28px 52px 16px;

                        & > div:not(:last-child) {
                            width: 140px;
                        }

                        &__legend {
                            font-weight: 400;
                            font-size: 12px;
                            line-height: 24px;
                        }
                        &__content {
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 16px;
                            color: rgba(black, 0.87);
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 768px) {
    .@{prefix} {
        &__card {
            width: 100vw;
            background: white;
            box-shadow: none;
            margin-top: -48px;
            padding-top: 24px;
        }

        &__title {
            font-size: 28px;
            line-height: 37px;
            padding: 0 0 30px 16px;
            border-bottom: none;
        }

        &__main {
            height: auto;
            flex-direction: column;
        }

        &__submenu {
            padding: 0;
            background: white;
            max-width: 100vw;
            width: auto;
            display: flex;
            flex-direction: row;

            & .common__submenu__item {
                margin-bottom: 0;
                padding: 10px 16px;
                text-align: center;
                width: 50vw;
                background: white;

                border-bottom: 1px solid rgba(black, 0.08);

                &.selected {
                    color: @primary-color;
                    border-bottom: 2px solid @primary-color;
                }
            }
        }

        &__body {
            margin-top: 16px;
            border-left: none;
            &__appcard {
                width: calc(100% - 24px);
                height: auto;
                border-radius: 24px;
                box-shadow: 0 24px 38px 3px rgba(black, 0.1), 0 9px 46px 8px rgba(black, 0.08), 0 11px 15px 0 rgba(black, 0.16);
                padding: 35px 8px 16px 8px;
                margin: 0 12px;
                flex-direction: column;

                &__left {
                    width: 216px;
                }

                &__dermx {
                    flex-direction: column;

                    margin-top: 16px;
                    width: 100%;

                }

                &__right {
                    margin: 20px 0 16px 0;
                    width: calc(100% - 48px);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    
                    &__leading-text {
                        display: none;
                    }

                    &__alt {
                        display: block;
                        width: 100%;
                        &__text {
                            line-height: 32px;
                            font-size: 21px;
                        }
                    }

                    &__middle-item {
                        margin-top: 0;
                        width: auto;

                        &:nth-of-type(2) {
                            margin-bottom: 24px;
                        }

                        &__bar {
                            width: 100%;
                        }

                        &__text {
                            margin-bottom: 24px;
                        }
                    }
                }

                &__btns {
                    flex-direction: column;
                    width: 216px;
                    height: 84px;
                    justify-content: space-between;

                    & button {
                        width: 100%;
                    }
                }
            }

            &__title {
                font-size: 28px;
                line-height: 37px;
            }

            &__scenarios {
                margin: 56px 16px 24px 16px;
                &__items {
                    margin-top: 28px;
                    width: 100%;
                }

                &__item {
                    width: auto;
                    margin-bottom: 32px;
                    
                    &__title {
                        margin-top: 12px;
                        line-height: 28px;
                    }

                    &__content {
                        margin-top: 15px;
                        line-height: 24px;
                        width: 152px;
                    }
                }
            }

            &__prices {
                padding: 56px 12px 34px 12px;

                & .app-detail__body__title {
                    margin-bottom: 21px;
                }
                
                &__card {

                    width: 100%;
                    height: auto;

                    &__title {
                        &__mode {
                            font-size: 18px;
                            line-height: 32px;
                        }
                        &__price {
                            font-size: 18px;
                            line-height: 32px;
                        }
                    }

                    &__subcard {
                        margin-top: 8px;
                        width: 100%;
                        padding: 24px 16px;
                        flex-wrap: wrap;
                        height: 176px;

                        & > div {
                            margin: 12px 0;
                            // text-align: center;
                            width: 140px;
                        }
                    }
                }
            }

        }

    }
    }
</style>